import Image from 'app/Components/Shared/Image/image';
import {ComponentProps} from '@episerver/spa-core/EpiComponent';
import CostumerFeedbackItemsBlockData from 'app/Models/Content/CostumerFeedbackItemsBlockData';
import CostumerFeedbackItemBlockData from 'app/Models/Content/CostumerFeedbackItemBlockData';
import React from 'react';
import {isMobile} from 'react-device-detect';
import CostumerFeedbackItem from './CostumerFeedbackItem';
import BlockWrapper from 'app/Components/Shared/BlockWrapper';

import {Swiper, SwiperSlide} from 'swiper/react';
import SwiperCore, {Autoplay, Navigation} from 'swiper';
import 'swiper/swiper.scss';
SwiperCore.use([Autoplay, Navigation]);

const CostumerFeedbackItemsBlock = (props: ComponentProps<CostumerFeedbackItemsBlockData>) => {
  const {data} = props;
  const items = data.items?.expandedValue?.map((item: CostumerFeedbackItemBlockData) => ({
    feedback: item.feedback.value,
    writername: item.writerName.value,
  }));

  return (
    <BlockWrapper props={props}>
      <div className='CostumerFeedbackItemsBlock'>
        {!isMobile && (
          <div className='CostumerFeedbackItemsBlock__items'>
            <div className='CostumerFeedbackItemsBlock__items__prev'>
              <Image src={require('./images/arrow-right.svg')} />
            </div>
            <Swiper
              navigation={{nextEl: '.CostumerFeedbackItemsBlock__items__next', prevEl: '.CostumerFeedbackItemsBlock__items__prev'}}
              slidesPerView={5}
              centeredSlides
              loop>
              {items?.map((item, i) => (
                <SwiperSlide key={i}>
                  <CostumerFeedbackItem data={item} />
                </SwiperSlide>
              ))}
            </Swiper>
            <div className='CostumerFeedbackItemsBlock__items__next'>
              <Image src={require('./images/arrow-right.svg')} />
            </div>
          </div>
        )}
        {isMobile && (
          <div className='CostumerFeedbackItemsBlock__items'>
            <Swiper autoplay={{delay: 4000}} centeredSlides slidesPerView={1.3} loop>
              {items?.map((item, i) => (
                <SwiperSlide key={i}>
                  <CostumerFeedbackItem data={item} />
                </SwiperSlide>
              ))}
            </Swiper>
          </div>
        )}
      </div>
    </BlockWrapper>
  );
};

export default CostumerFeedbackItemsBlock;
